import { render, staticRenderFns } from "./DnStatements.vue?vue&type=template&id=dc783fa0&scoped=true&"
import script from "./DnStatements.vue?vue&type=script&lang=js&"
export * from "./DnStatements.vue?vue&type=script&lang=js&"
import style0 from "./DnStatements.vue?vue&type=style&index=0&id=dc783fa0&lang=scss&scoped=true&"
import style1 from "./DnStatements.vue?vue&type=style&index=1&id=dc783fa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc783fa0",
  null
  
)

export default component.exports